import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../_App/Redux/hooks";

import PaginationLayout from "../../_Layouts/Pagination/PaginationLayout";
import ActionModel from "./ActionModel";
import Filtre from "../Stock/Filtre";
import {
  currentpage,
  findActionApi,
  ListMouvement,
  mouvementArticleApi,
  totalPages,
} from "../../_App/Redux/Slices/mouvement/mouvementSlice";
import TicketDeCaissePaid from "../Caisses/TicketDeCaisse/TicketDeCaissePaid";
import {
  Dateformat,
  exportExcel,
  formatDate,
  formatDateAndTime,
  formatTime,
  Timeformat,
} from "../../_App/Helpers/helpers";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import {
  ListActionsMouvement,
  optionsActionsMouvement,
} from "../../_App/Data/ListActionsMouvement";
import { findPaymentsByTicketApi } from "../../_App/Redux/Slices/payments/PaymentSlice";
import ReceptionForm from "../Reception/ReceptionForm";
import TicketArticle from "../TicketArticle/TicketArticle";
import {
  SelectedOrganisations,
  societeId,
} from "../../_App/Redux/Slices/Auth/authSlice";
import { parametrageCaisse } from "../../_App/Redux/Slices/AppParametrages/caisseParametrages/caisseParametrageSlice";
import TicketCaissePaidModalMinime from "../Caisses/TicketDeCaisse/TicketCaissePaidModalMinime";
import InventaireDetaliTable from "../Inventaire/InventaireDetaliTable";

export default function Mouvement() {
  const { t } = useTranslation();

  type datafilterType = {
    carte: any;
    categories: any;
    sousCategories: any;
    carateristique: any;
    index: number;
    ref1: any;
    ref2: any;
    prix1: any;
    prix2: any;
    idarticle: any;
  };
  const dispatch = useAppDispatch();
  const OrganisationList = useAppSelector(SelectedOrganisations);
  const listMouvement = useAppSelector(ListMouvement);
  const societe = useAppSelector(societeId);
  const [keyword, setkeyword] = useState("");
  const [date_debut, setdate_debut] = useState("");
  const [date_fin, setdate_fin] = useState("");
  const [dataOrder, setdataOrder] = useState("DESC");
  const [selectedActions, setSelectedActions] =
    useState<any[]>(ListActionsMouvement);
  const [selectedCarte, setSelectedCarte] = useState<any[]>([]);
  const [selectedCategorie, setSelectedCategorie] = useState<any[]>([]);
  const [selectedSousCategorie, setSelectedSousCategorie] = useState<any[]>([]);
  const [showModalTicket, setShowModalTicket] = useState(false);
  const [order_id, setorder_id] = useState(null);
  const [categoriesOptions, setcategoriesdOptions] = useState<any[]>([]);
  const [souscategoriesOptions, setsouscategoriesdOptions] = useState<any[]>(
    []
  );
  const [selectedorganisation, setselectedorganisation] = useState<any[]>([]);

  const [intervaleRef, setintervaleRef] = useState<any>();
  const [intervalePrix, setintervalePrix] = useState<any>();
  const [ticket, SetTicket] = useState(null);
  const [NLigne, setNLigne] = useState(200);
  interface SelectionsState {
    [key: string]: any[];
  }
  const [datafilter, setdatafilter] = useState<datafilterType>();

  const [selections, setSelections] = useState<SelectionsState>({});
  const [spinner, setspinner] = useState(false);
  const current_page = useAppSelector(currentpage);
  const totalpages = useAppSelector(totalPages);
  const [index, setindex] = useState(!current_page ? 1 : current_page);
  const [action, setaction] = useState();
  const [modelAction, setmodelAction] = useState(false);
  const [article_id, setarticle_id] = useState("");
  const [showModalReception, setshowReception] = useState(false);
  const [showModalDetails, setshowModalDetails] = useState(false);

  const [reception, setreception] = useState(null);
  const [inventaire, setinventaire] = useState(null);
  const [list_inventaire_details, setlist_inventaire_details] = useState<any>();
  const [OrganisationOption, setOrganisationOption] = useState<any[]>([]);

  const [showModelTicket, setshowModelTicket] = useState(false);
  const [listTicket, setlistTicket] = useState([]);
  const parametrage_caisse = useAppSelector(parametrageCaisse);
  useEffect(() => {
    const today = new Date();
    const lastMonth = new Date(today);
    lastMonth.setMonth(today.getMonth() - 1);

    setdate_debut(formatDate(lastMonth));
    setdate_fin(formatDate(today));
    const data = {
      carte: [],
      categories: [],
      sousCategories: [],
      carateristique: [],
      index: index,
      keyword: "",
      dateDebut: formatDate(lastMonth),
      dateFin: formatDate(today),
      ref1: intervaleRef?.ref1,
      ref2: intervaleRef?.ref2,
      prix1: intervalePrix?.prix1,
      prix2: intervalePrix?.prix2,
      order: dataOrder,
      actions: selectedActions,
      idarticle: article_id,
      societe_id: societe,
      Nligne: NLigne || 200,
      organisation: selectedorganisation,
    };
    setindex(index);
    setdatafilter(data);
    dispatch(mouvementArticleApi(data));
  }, []);
  useEffect(() => {
    if (OrganisationList)
      setOrganisationOption(
        OrganisationList?.map((option) => ({
          value: option._id,
          label: option.nom,
        }))
      );
  }, [OrganisationList]);
  useEffect(() => {
    setspinner(false);
  }, [listMouvement]);
  const findMouvement = async (articleid?: any) => {
    if (typeof articleid !== "string") {
      setarticle_id("");
    }
    setspinner(true);

    const carateristiqueOptions: any[] = [];

    for (const key in selections) {
      if (Array.isArray(selections[key])) {
        selections[key].forEach((obj) => {
          carateristiqueOptions.push(obj.value);
        });
      }
    }
    const data = {
      carte: selectedCarte,
      categories: selectedCategorie,
      sousCategories: selectedSousCategorie,
      carateristique: carateristiqueOptions,
      index: 1,
      keyword: encodeURIComponent(keyword),
      dateDebut: date_debut,
      dateFin: date_fin,
      ref1: intervaleRef?.ref1,
      ref2: intervaleRef?.ref2,
      prix1: intervalePrix?.prix1,
      prix2: intervalePrix?.prix2,
      order: dataOrder,
      actions: selectedActions,
      idarticle: typeof articleid === "string" ? articleid : "",
      Nligne: NLigne || 200,
      societe_id: societe,
      organisation: selectedorganisation,
    };
    setindex(1);
    setdatafilter(data);
    dispatch(mouvementArticleApi(data));
  };
  const handelSelectOrganisation = (selectedOption: any) => {
    const listOrganisations = selectedOption.map((item: any) => item.value);
    setselectedorganisation(listOrganisations);
  };
  useEffect(() => {
    setspinner(true);

    const carateristiqueOptions: any[] = [];

    for (const key in selections) {
      if (Array.isArray(selections[key])) {
        selections[key].forEach((obj) => {
          carateristiqueOptions.push(obj.value);
        });
      }
    }
    const data = {
      carte: selectedCarte,
      categories: selectedCategorie,
      sousCategories: selectedSousCategorie,
      carateristique: carateristiqueOptions,
      index: index,
      keyword: encodeURIComponent(keyword),
      dateDebut: date_debut,
      dateFin: date_fin,
      ref1: intervaleRef?.ref1,
      ref2: intervaleRef?.ref2,
      prix1: intervalePrix?.prix1,
      prix2: intervalePrix?.prix2,
      order: dataOrder,
      actions: selectedActions,
      idarticle: article_id,
      Nligne: NLigne || 200,
      societe_id: societe,
      organisation: selectedorganisation,
    };
    setindex(index);
    setdatafilter(data);
    dispatch(mouvementArticleApi(data));
  }, [index]);
  const findAction = async (id: string) => {
    const action = await dispatch(findActionApi(id));
    if (action?.payload && action?.payload?.data?.length !== 0) {
      if (action.payload?.type === "Reception") {
        setreception(action.payload.data);
        setshowReception(true);
      } else if (action.payload?.type === "Inventaire") {
        setinventaire(action.payload.data.inventaire);

        setlist_inventaire_details({
          [id.toString()]: action.payload.data.details,
        });
        setshowModalDetails(true);
      } else {
        setaction(action.payload);
        setmodelAction(true);
      }
    }
  };

  const findCode = (item: any) => {
    if (item?.id_Reservation) {
      return item?.id_Reservation?.code_commande?.order_number;
    }
   else if (item.ticket_id) {
      return item?.ticket_id?.ticket_order?.order_number;
    } else if (item.id_achat) {
      return item?.id_achat?.refAchat;
    } else if (item?.id_Reception) {
      return item?.id_Reception?.code_reception;
    } else if (item?.id_Transfert) {
      return item?.sens === "sortie"
        ? item?.id_Transfert?.NumBontransfert
        : item?.id_Transfert?.NumBonreception;
    } else if (item?.id_Inventaire) {
      return item?.id_Inventaire?.code_inventaire;
    } else if (item?.order_id) {
      return item?.order_id?.order_number;
    } else {
      return "--";
    }
  };
  const exportToExcel = async () => {
    setspinner(true);

    const carateristiqueOptions: any[] = [];

    for (const key in selections) {
      if (Array.isArray(selections[key])) {
        selections[key].forEach((obj) => {
          carateristiqueOptions.push(obj.value);
        });
      }
    }
    const data = {
      carte: selectedCarte,
      categories: selectedCategorie,
      sousCategories: selectedSousCategorie,
      carateristique: carateristiqueOptions,
      index: 1,
      keyword: encodeURIComponent(keyword),
      dateDebut: date_debut,
      dateFin: date_fin,
      ref1: intervaleRef?.ref1,
      ref2: intervaleRef?.ref2,
      prix1: intervalePrix?.prix1,
      prix2: intervalePrix?.prix2,
      order: dataOrder,
      excel: true,
      actions: selectedActions,
      idarticle: article_id,
      societe_id: societe,
      Nligne: NLigne || 200,
      organisation: selectedorganisation,
    };
    const resp = await dispatch(mouvementArticleApi(data));
    if (resp.payload.success) {
      const list = resp.payload.data.data.map((item: any) => ({
        Famille: item.article?.souscategorie?.libelle?.fr,
        Article: item.article?.titre?.fr,
        Action: item.movements?.order_id
          ? t("Vente")
          : item.movements?.id_achat
          ? t("Reception")
          : item.movements?.id_Transfert
          ? t("Transfert")
          : item.movements?.id_Inventaire
          ? t("Inventaire")
          : item.movements?.id_Reservation
          ? t("Avance")
          : "",
        Organisation: item.movements?.organisation_id?.nom,
        Depots: item.movements?.position_depot?.libelle,
        Sens: item.movements?.sens,
        Source_Destination:
          item?.movements?.sens === "sortie"
            ? item?.movements.id_Transfert?.organisation_demande?.nom
            : item?.movements.id_Transfert?.organisation_transfer?.nom,
        Type: item.movements?.type,
        Quantite: item.movements?.quantite,

        "Prix Total": Number(item.movements?.prix_ttc?.toFixed(3)),
        Date: formatDateAndTime(item.movements?.createdAt),
      }));
      exportExcel("mouvements.xlsx", "Mouvements", list);
    }
    setspinner(false);
  };
  const handleSelectChange = (selectedOptions: any) => {
    setSelectedActions(selectedOptions.map((option: any) => option.value));
  };

  return (
    <>
      <div className=" row  bg-white" style={{ padding: "20px" }}>
        <h3>{t("Liste des mouvements des articles")}</h3>
        <div className="col-2">
          <label>{t("Date debut")}</label>
          <input
            type="date"
            className="form-control "
            value={date_debut}
            onChange={(e) => setdate_debut(e.target.value)}
          />
        </div>
        <div className="col-2">
          <label>{t("Date fin")}</label>
          <input
            type="date"
            className="form-control "
            value={date_fin}
            onChange={(e) => setdate_fin(e.target.value)}
          />
        </div>
        <div className="col-3">
          <label>{t("Filre action")}</label>
          <Select
            isMulti
            name="actions"
            options={optionsActionsMouvement}
            value={optionsActionsMouvement.filter((option) =>
              selectedActions.includes(option.value)
            )}
            onChange={handleSelectChange}
          />
        </div>
        <div className="col-2">
          <label>{t("Organisation")}</label>
          <Select
            isMulti
            options={OrganisationOption}
            isSearchable={true}
            onChange={handelSelectOrganisation}
            value={selectedorganisation?.map((item: any) =>
              OrganisationOption?.find((cat: any) => cat.value === item)
            )}
          />
        </div>
        <div className="col-1">
          <label>{t(" Order")}</label>
          <select
            className="form-control"
            value={dataOrder}
            onChange={(e) => setdataOrder(e.target.value)}
          >
            <option value={"DESC"}>{t("DESC")}</option>
            <option value={"ASC"}>{t("ASC")}</option>
          </select>
        </div>
        <div className="col-1">
          <button
            onClick={exportToExcel}
            className="btn btn-export"
            style={{ float: "right" }}
          >
            <i className="far fa-file-excel fa-lg mb-2"></i>
            {t(" Excel")}
          </button>
        </div>
        <Filtre
          spinner={spinner}
          handleSearch={findMouvement}
          setkeyword={setkeyword}
          t={t}
          setspinner={setspinner}
          setdatafilter={setdatafilter}
          setindex={setindex}
          searchfiltre={findMouvement}
          selectedCarte={selectedCarte}
          setSelectedCarte={setSelectedCarte}
          selectedCategorie={selectedCategorie}
          setSelectedCategorie={setSelectedCategorie}
          selectedSousCategorie={selectedSousCategorie}
          setSelectedSousCategorie={setSelectedSousCategorie}
          categoriesOptions={categoriesOptions}
          setcategoriesdOptions={setcategoriesdOptions}
          souscategoriesOptions={souscategoriesOptions}
          setsouscategoriesdOptions={setsouscategoriesdOptions}
          selections={selections}
          setintervaleRef={setintervaleRef}
          intervaleRef={intervaleRef}
          setintervalePrix={setintervalePrix}
          intervalePrix={intervalePrix}
          setSelections={setSelections}
          setNLigne={setNLigne}
          NLigne={NLigne}
        />

       
      </div>
      <div className="row layout-spacing mt-5">
        <div className="col-lg-12   bg-white  ">
          <div className="table-responsive">
            <table className="table">
              <thead>
                <th colSpan={2}>{t("Famille")}</th>
                <th>{t("Article")}</th>
                <th>{t("Action")}</th>
                <th>{t("Action code")}</th>
                <th>{t("Organisation")}</th>
                <th>{t("Depots")}</th>
                <th>{t("Sens")}</th>
                <th>{t("Source / Destination")}</th>
                <th> {t("Type")}</th>
                <th>{t("Qte avant")}</th>
                <th>{t("Quantite")}</th>
                <th>{t("Qte apres")}</th>

                <th>{t("P.U TTC")}</th>
                <th>{t("Prix TTC")}</th>
                <th>{t("Date  ")}</th>
                <th>{t("Time  ")}</th>
              </thead>
              <tbody>
                {listMouvement &&
                  listMouvement.length !== 0 &&
                  listMouvement.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        background:
                          item?.transfert &&
                          !item?.transfert.approver_reception?.etat
                            ? "red"
                            : "",
                      }}
                    >
                      <td style={{ color: "red" }}>
                        {item?.movements?.removed
                          ? t("Vente annulée")
                          : item?.movements?.orderAnnuleNumber}
                      </td>

                      <td style={{ background: "inherit", fontSize: "16px" }}>
                        {article_id == "" && (
                          <i
                            onDoubleClick={() => {
                              setarticle_id(item?.article?._id);
                              findMouvement(item?.article?._id);
                            }}
                            className="fas fa-compress-arrows-alt"
                          ></i>
                        )}{" "}
                        {item?.article?.souscategorie?.libelle?.fr}
                      </td>
                      <td style={{ background: "inherit", fontSize: "16px" }}>
                        {item?.article?.titre?.fr}
                      </td>
                      <td
                        style={{ background: "inherit", fontSize: "16px" }}
                        onClick={async () => {
                          if (item?.movements?.order_id) {
                            setorder_id(item?.movements?.order_id);
                            await dispatch(
                              findPaymentsByTicketApi(
                                item?.movements?.ticket_id?._id
                              )
                            );

                            SetTicket(item?.movements?.ticket_id);

                            setShowModalTicket(true);
                          } else {
                            findAction(
                              item?.movements?.id_achat
                                ? item?.movements?.id_achat?._id
                                : item?.movements?.id_Transfert
                                ? item?.movements?.id_Transfert?._id
                                : item?.movements?.id_Inventaire
                                ? item?.movements?.id_Inventaire?._id
                                : item?.movements?.id_Reservation
                                ? item?.movements?.id_Reservation?._id
                                : item?.movements?.id_BonSortie
                                ? item?.movements?.id_BonSortie
                                : item?.movements?.id_Reception?._id
                            );
                          }
                        }}
                      >
                        <span className="lien-bleu-souligne">
                          {item?.movements?.id_achat && "Achat"}
                          {item?.movements?.id_Reception && "Reception"}

                          {item?.movements?.id_Transfert && "Transfert"}
                          {item?.movements?.id_Inventaire && "Inventaire"}
                          {(item?.movements?.id_Reservation &&
                            " Avance " +
                              item?.movements?.avance
                                ?.reduce(
                                  (sum: any, item: any) =>
                                    sum + (item.total || 0),
                                  0
                                )
                                .toFixed(3)) ||
                            ""}
                          {item?.movements?.order_id && item?.movements?.type}
                          {item?.movements?.id_BonSortie && "Bon Sortie"}
                        </span>
                      </td>
                      <td>{findCode(item?.movements)}</td>
                      <td style={{ background: "inherit", fontSize: "16px" }}>
                        {item?.movements?.organisation_id?.nom}
                      </td>
                      <td style={{ background: "inherit", fontSize: "16px" }}>
                        {item?.movements?.position_depot?.libelle}
                      </td>

                      <td style={{ background: "inherit", fontSize: "16px" }}>
                        {item?.movements?.sens}
                      </td>
                      <td style={{ background: "inherit", fontSize: "16px" }}>
                        {item?.movements?.sens === "sortie" ? (
                          <p>
                            {" "}
                            {item?.movements.id_Transfert? 
                            item?.movements.id_Transfert.organisation_demande !== null
                              ?   item?.movements.id_Transfert.organisation_demande?.nom
                              : item?.movements.id_Transfert?.depots_reception?.libelle
                              :''
                              }
                          </p>
                        ) : (
                          <p>
                            {item?.movements.id_Transfert? 
                            item?.movements.id_Transfert.organisation_transfer !== null
                              ?   item?.movements.id_Transfert.organisation_transfer?.nom
                              : item?.movements.id_Transfert?.depots_id?.libelle
                              :''
                              }
                          </p>
                        )}
                      </td>
                      <td style={{ background: "inherit", fontSize: "16px" }}>
                        {item?.movements?.type}
                      </td>
                      <td style={{ background: "inherit", fontSize: "16px" }}>
                        {item.movements?.stockBefore}
                      </td>
                      <td
                        style={{
                          fontSize: "16px",
                          fontWeight: "bolder",
                          color: "black",
                          background:
                            item?.movements?.sens === "sortie"
                              ? "red"
                              : "green",
                        }}
                      >
                        {item?.movements?.sens === "sortie" ? "-" : ""}
                        {item?.movements?.quantite}
                      </td>

                      <td style={{ background: "inherit", fontSize: "16px" }}>
                        {item.movements?.stockAfter}
                      </td>
                      <td style={{ background: "inherit", fontSize: "16px" }}>
                        {item?.movements?.prix_ttc?.toFixed(3)}
                      </td>
                      <td style={{ background: "inherit", fontSize: "16px" }}>
                        {item?.movements?.sens === "sortie" ? "-" : ""}
                        {Number(
                          (
                            item?.movements?.prix_ttc *
                            item?.movements?.quantite
                          )?.toFixed(3)
                        ) || ""}
                      </td>

                      <td
                        style={{
                          background: "inherit",
                          fontSize: "16px",
                          width: "150px",
                        }}
                      >
                        {Dateformat(item?.movements?.createdAt)}
                      </td>
                      <td style={{ background: "inherit", fontSize: "16px" }}>
                        {Timeformat(item?.movements?.createdAt)}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div className="row layout-spacing">
        <PaginationLayout
          index={index}
          nbrpage={current_page}
          totalpages={totalpages}
          setindex={setindex}
        />
      </div>
      <ActionModel
        t={t}
        data={action}
        showModal={modelAction}
        setshowModal={setmodelAction}
      />
      {parametrage_caisse?.ticketTemplate === "small" ? (
        <TicketCaissePaidModalMinime
          ShowModal={showModalTicket}
          setShowModal={setShowModalTicket}
          ticket={ticket}
        />
      ) : (
        <TicketDeCaissePaid
          ShowModal={showModalTicket}
          setShowModal={setShowModalTicket}
          ticket={ticket}
        />
      )}

      <ReceptionForm
        ShowModal={showModalReception}
        setShowModal={setshowReception}
        reception={reception}
        setshowModelTicket={setshowModelTicket}
        showModelTicket={showModelTicket}
        setlistTicket={setlistTicket}
      />
      {showModalDetails && (
        <InventaireDetaliTable
          t={t}
          setShowModal={setshowModalDetails}
          ShowModal={showModalDetails}
          listInventairedetails={list_inventaire_details}
          inventaire={inventaire}
          mvt={true}
        />
      )}

      <TicketArticle
        t={t}
        ShowModal={showModelTicket}
        setShowModal={setshowModelTicket}
        tickets={listTicket}
        stateQte={false}
         impression={true}
      />
    </>
  );
}
